module.exports = __webpack_public_path__ + "img/01.1840d62f.jpg";